import React from 'react'

const Footer = () => (
    <footer className="c-footer">
        Made with React - <a href="http://driesstandaert.com" className="c-footer__link">driesstandaert.com</a>
    </footer>
)

export default Footer;